module.exports = __webpack_public_path__ + "img/file_icon_large.100aed4c.svg";